__turbopack_context__.v({
  "ask": "mQzymG_ask",
  "askLink": "mQzymG_askLink",
  "askMark": "mQzymG_askMark",
  "fact": "mQzymG_fact",
  "factLabel": "mQzymG_factLabel",
  "factValue": "mQzymG_factValue",
  "facts": "mQzymG_facts",
  "glyph": "mQzymG_glyph",
  "glyphBox": "mQzymG_glyphBox",
  "line": "mQzymG_line",
  "lines": "mQzymG_lines",
  "panel": "mQzymG_panel",
});
